<div class="kl-image-cropper-dialog">
  <input
    #fileInputRef
    type="file"
    accept="image/*"
    class="kl-image-cropper-dialog__file-input"
    (change)="onFileSelected($event)" />

  @if (imageBase64() || imageChangedEvent()) {
    <div class="kl-image-cropper-dialog__work">
      <div class="kl-image-cropper-dialog__stage">
        <image-cropper
          [imageBase64]="imageBase64()"
          [imageChangedEvent]="imageChangedEvent()"
          [maintainAspectRatio]="false"
          [containWithinAspectRatio]="false"
          [resizeToWidth]="0"
          [output]="'base64'"
          format="jpeg"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded($event)"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()" />
      </div>

      <div class="kl-image-cropper-dialog__preview-pane">
        <div class="kl-image-cropper-dialog__preview">
          @if (croppedImage(); as preview) {
            <img [src]="preview" alt="" />
          } @else {
            <div class="kl-image-cropper-dialog__preview-empty">
              <i class="ph ph-image" aria-hidden="true"></i>
              <span>{{ 'preview' | translate }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="kl-image-cropper-dialog__empty">
      <i class="ph ph-image" aria-hidden="true"></i>
      <span>{{ 'upload_image' | translate }}</span>
    </div>
  }
</div>

<div class="kl-dialog-footer">
  <div class="kl-dialog-footer__left">
    <p-button type="button" severity="secondary" [label]="'upload_image' | translate" (onClick)="openFilePicker()" />
  </div>
  <div class="kl-dialog-footer__right">
    <p-button type="button" [label]="'save' | translate" [disabled]="!imageReady()" (onClick)="applyCrop()" />
    <p-button type="button" severity="secondary" [label]="'close' | translate" (onClick)="close()" />
  </div>
</div>
